<template>
    <div class="text-truncate">
        {{ truncate ? this.slicedText : text }}
        <template v-if="isSliced">
            <span v-if="truncate" @click="truncate = false">See more <i class="el-icon-arrow-down"></i></span>
            <span v-else @click="truncate = true">See less <i class="el-icon-arrow-up"></i></span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'text-truncate',

    data() {
        return {
            truncate: true
        }
    },

    props: {
        text: {
            type: String,
            required: true
        },
        maxLength: {
            type: Number,
            required: true
        }
    },

    computed: {
        isSliced() {
            return this.text.length > this.maxLength
        },
        slicedText() {
            return this.text.slice(0, this.maxLength) + (this.isSliced ? '...' : '')
        }
    }
}
</script>

<style lang="scss" scoped>
div.text-truncate {
    word-break: break-word;
    span {
        cursor: pointer;
        font-size: 10px;
        color: #2874e8;
        white-space: nowrap;
    }
}
</style>
